export default "https://assets.pclncdn.com/web/next-landing/6889411/_next/static/images/pcln-hp-hero-packages-70db518ab4d4d0a52536e6dcc22c1e4a.webp";